import React from "react";
import DataService from "services/DataService";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import constants from "../../constants/User/user";
import { useUser } from "../../context/userContext";
import { useAlert } from "../../context/Feedback/alertContext";
import { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import styles from "../../assets/jss/material-dashboard-react/components/dialogHowToUse";
import "./classes.css";

import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";

import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import "./userDialog.css";
const useStyles = makeStyles(styles);

export default function ChangePasswordDialog() {
  const {
    isActiveChangePasswordDialog,
    setActiveChangePasswordDialog,
    language,
    credential,
    user,
  } = useUser();

  const { setAlert } = useAlert();
  const [checked, setChecked] = useState(true);
  const [lastPassword, setLastPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");

  const classes = useStyles();

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };
  const handleCancel = () => {
    setActiveChangePasswordDialog(false);
  };

  const updatePassword = async (event) => {
    event.preventDefault();
    const authorization = {
      headers: {
        Authorization: credential,
      },
    };
    try {
      await DataService.changePass(
        user.email,
        lastPassword,
        newPassword,
        authorization
      );

      setAlert({
        active: true,
        text: constants.alerts.attPasswordSucceed[language],
        color: "success",
        sevarity: "info",
      });
      setNewPassword("");
      setLastPassword("");
    } catch (e) {
      setAlert({
        active: true,
        text: constants.alerts.attPasswordFail[language],
        color: "danger",
        sevarity: "info",
      });
      setNewPassword("");
      setLastPassword("");
    }
  };

  return (
    <div>
      <Dialog
        checked={checked}
        onChange={handleChange}
        open={isActiveChangePasswordDialog}
        keepMounted
        onClose={handleCancel}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle className={classes.dialog} id="alert-dialog-slide-title">
          <div className="wrapper-title">
            {constants.modal.changePassword[language]}
            <div className="wrapper-button-close">
              <Button onClick={handleCancel}>X</Button>
            </div>
          </div>
        </DialogTitle>
        <DialogContent className={classes.dialog}>
          <Grid container justifyContent="center">
            <GridItem xs={12} sm={12} md={12}>
              <Card>
                <CardHeader>
                  <h4 className={classes.cardTitleWhite}>
                    {constants.modal.changePassword[language]}
                  </h4>
                </CardHeader>
                <CardBody>
                  <form onSubmit={updatePassword}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={12}>
                        <CustomInput
                          labelText={constants.user.lastPassword[language]}
                          onChange={(e) => {
                            setLastPassword(e.target.value);
                          }}
                          id="change-password-last-name"
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            type: "password",
                            required: true,
                            value: lastPassword,
                            autoComplete: "current-password",
                            name: "lastPassword",
                          }}
                        />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={12}>
                        <CustomInput
                          labelText={constants.user.newPassword[language]}
                          onChange={(e) => {
                            setNewPassword(e.target.value);
                          }}
                          id="change-password-new-password"
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            type: "password",
                            required: true,
                            value: newPassword,
                            autoComplete: "new-password",
                            name: "newPassword",
                          }}
                        />
                      </GridItem>
                    </GridContainer>
                    <CardFooter>
                      <Button color="success" type="submit">
                        {constants.user.attPassword[language]}
                      </Button>
                      <Button
                        color="danger"
                        onClick={() => {
                          handleCancel();
                        }}
                      >
                        {constants.user.cancel[language]}
                      </Button>
                    </CardFooter>
                  </form>
                </CardBody>
              </Card>
            </GridItem>
          </Grid>
        </DialogContent>
        <DialogActions className={classes.dialog}></DialogActions>
      </Dialog>
    </div>
  );
}
